
import {useI18n} from 'vue-i18n';
import {computed, defineComponent} from 'vue';
import {getPortalUrl} from '@/utils/portalUrl';

export default defineComponent(
    {
      name: 'JoinSection',
      setup() {
        const {t, locale} = useI18n();
        const registerUrl = computed(() => getPortalUrl('register', locale.value));
        return {t, locale, registerUrl};
      },
    }
);
